import { useEffect } from "react";

export const triggerRefresh = () => window.dispatchEvent(new Event("sp-refresh"));

export function useRefresh(fn, deps = []) {
  useEffect(() => {
    fn();
    window.addEventListener("sp-refresh", fn);
    return () => window.removeEventListener("sp-refresh", fn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
